import { useEffect, useState } from '@redneckz/uni-jsx/lib/hooks';
export const getNS = (_) => globalThis[_];
export const initializeExternalNS = (namespaceName, url) => {
    const script = document.getElementById(url);
    if (script) {
        const ns = getNS(namespaceName);
        if (ns) {
            return Promise.resolve(ns);
        }
        else {
            return new Promise((resolve) => {
                script.addEventListener('load', () => {
                    resolve(getNS(namespaceName));
                });
            });
        }
    }
    else {
        return new Promise((resolve, reject) => {
            const newScript = document.createElement('script');
            newScript.src = url;
            newScript.async = true;
            newScript.id = url;
            newScript.addEventListener('load', () => {
                resolve(getNS(namespaceName));
            });
            newScript.addEventListener('error', (error) => {
                reject(error);
            });
            document.head.appendChild(newScript);
        });
    }
};
export function useExternalNS(namespaceName, url, unmountNS = true) {
    const [externalNS, setExternalNS] = useState(undefined);
    useEffect(() => {
        let isMounted = true;
        initializeExternalNS(namespaceName, url)
            .then((ns) => {
            if (isMounted) {
                setExternalNS(ns);
            }
        })
            .catch((error) => {
            console.error(`Failed to initialize external namespace: ${error}`);
        });
        return () => {
            isMounted = false;
            if (unmountNS) {
                const script = document.getElementById(url);
                if (script) {
                    document.head.removeChild(script);
                }
                setExternalNS(undefined);
            }
        };
    }, [namespaceName, url, unmountNS]);
    return externalNS;
}
//# sourceMappingURL=useExternalNS.js.map